import WeekCalendarRecord from './WeekCalendarRecord';

export default WeekCalendarRecord;
